import React, { Component } from "react";
import BRSpan from "../General/BRSpan";
class DonorFullPage extends Component {
  renderDonorLines = () => {
    let counter = 0;
    let h_spacing = this.props.width / this.props.columns;
    let v_spacing = this.props.height / this.props.rows;
    let r_margin = 0;
    if (this.props.overrideMarginRight) {
      r_margin = this.props.overrideMarginRight;
    }

    const fontSize = this.props.overrideFontSize > 0 ? this.props.overrideFontSize : v_spacing * 0.5;

    let lineHeight = "normal";
    if (this.props.overrideLineHeightModifier) {
      lineHeight = fontSize * this.props.overrideLineHeightModifier + "px";
    }

    let previousHasBr = false;
    let acc = 0;
    return this.props.donorData.map(function (row, i) {
      if (this.props.sort === "row") {
        return (
          <span className={this.props.fontclass} key={i} style={{ fontSize, lineHeight }}>
            <span
              style={{
                position: "absolute",
                left: counter * h_spacing,
                width: h_spacing - r_margin,
                top: v_spacing * Math.floor(i / this.props.columns)
              }}
              key={i}
            >
              <BRSpan preWrap str={row.name} />
            </span>
            {counter++ === this.props.columns - 1 ? <span /> : <span />}
            <span style={{ display: "none" }}>{counter === this.props.columns ? (counter = 0) : null}</span>
          </span>
        );
      } else {
        //column
        let top = counter * v_spacing + this.rowBreakPadding(counter);
        if (this.props.evenVerticalSpace) {
          if (counter === 0) {
            acc = 0;
            previousHasBr = false;
          }

          if (counter > 0) {
            top -= acc;
          }

          previousHasBr = row.name.includes("<br>");

          if (!previousHasBr) {
            acc += (this.props.width * 1.79398148148148148148) / 100;
          }
        }

        return (
          <span className={this.props.fontclass} key={i} style={{ fontSize, lineHeight }}>
            <span
              style={{
                position: "absolute",
                left: h_spacing * Math.floor(i / this.props.rows),
                width: h_spacing - r_margin,
                top: top
              }}
              key={i}
            >
              <BRSpan preWrap str={row.name} />
            </span>
            {counter++ === this.props.rows - 1 ? <span /> : <span />}
            <span style={{ display: "none" }}>{counter === this.props.rows ? (counter = 0) : null}</span>
          </span>
        );
      }
    }, this);
  };

  rowBreakPadding = (index, rules) => {
    if (this.props.custom1x2 && index >= 8) {
      return this.props.screen.sv.p10 * 0.65;
    } else {
      return 0;
    }
  };

  renderDonorName(name) {
    let splitline = false;
    if (name.includes("<br>")) {
      name = name.split("<br>");
      splitline = true;
    }
    if (splitline === false) {
      return name;
    } else {
      return name.map(function (row, i) {
        return (
          <span key={i}>
            {row}
            {i < name.length ? <br /> : <span />}
          </span>
        );
      });
    }
  }

  render() {
    let dlines = this.renderDonorLines();
    return (
      <div style={{ position: "absolute", top: 0, left: 0 }}>
        {dlines}
      </div>
    );
  }
}

export default DonorFullPage;



// WEBPACK FOOTER //
// ./src/Components/Donor/DonorFullPage.js